export enum FileKind {
  TYPE = "type",
  TEMPLATE = "template",
  CLASS = "class",
  FOLDER = "folder",
}
